import throttle from 'lodash/throttle';

import {
	SITE_LOGO_BIG_BORDER_WIDTH,
	SITE_LOGO_BIG_SIZE,
	SITE_LOGO_BIG_TOTAL_HEIGHT,
	SITE_LOGO_SMALL_BORDER_WIDTH,
	SITE_LOGO_SMALL_SIZE,
} from '../../_variables';

import breakpoint from '../../helpers/breakpoint';
import createStore from '../../helpers/createStore';

import {getBoundingClientRect} from './helpers/getBoundingClientRect';
import * as breadcrumb from './breadcrumb';
import * as bigLogo from './big-logo';

const SELECTOR_BASE = '.bs-site-logo';
const SCROLL_AND_RESIZE_THROTTLE = 150; // ms

const noop = () => undefined;

function init(logoE) {
	const introStageE = document.querySelector(
		'.js-bs-intro-stage, .js-bs-intro-image'
	);

	const store = createStore({
		isScrolled: null,
		lastIsScrolled: null,
	});

	const updateBreadcrumb = breadcrumb.match(logoE)
		? breadcrumb.init(store)
		: noop;
	const updateLogo = bigLogo.match(logoE)
		? bigLogo.init(store, logoE, introStageE)
		: noop;

	function checkIfLogoFitsInVisibleIntro() {
		const {bottom: introBottom} = getBoundingClientRect(introStageE);
		return (
			introBottom !== 0 &&
			introBottom < SITE_LOGO_BIG_TOTAL_HEIGHT
		);
	}

	function handleScrollOrViewportChange({forceUpdate = true} = {}) {
		const lastIsScrolled = store.getState().isScrolled;
		const isMobile = breakpoint('mobile');
		const isScrolled =
			introStageE === null
				? true
				: checkIfLogoFitsInVisibleIntro(isMobile);
		store.setState({
			lastIsScrolled: lastIsScrolled,
			isScrolled: isScrolled,
		});

		if (forceUpdate || isScrolled !== lastIsScrolled) {
			const isSmall = isScrolled || isMobile;
			const borderWidth = isSmall
				? SITE_LOGO_SMALL_BORDER_WIDTH
				: SITE_LOGO_BIG_BORDER_WIDTH;
			const logoSize = isSmall
				? SITE_LOGO_SMALL_SIZE
				: SITE_LOGO_BIG_SIZE;

			store.setState({
				borderWidth: borderWidth,
				logoSize: logoSize,
			});

			updateBreadcrumb();
			updateLogo();
		}
	}

	handleScrollOrViewportChange({forceUpdate: true});
	logoE.classList.add('bs-site-logo--inited');

	const handlerThrottled = throttle(
		handleScrollOrViewportChange,
		SCROLL_AND_RESIZE_THROTTLE
	);
	window.addEventListener(
		'resize',
		() => handlerThrottled({forceUpdate: true}),
		{passive: true}
	);

	if (introStageE !== null) {
		window.addEventListener(
			'scroll',
			() => handlerThrottled({forceUpdate: false}),
			{passive: true}
		);
	}

	// We add a class, so we can apply css transitions only after the initial run is done
	requestAnimationFrame(() => {
		logoE.classList.add('bs-site-logo--with-transition');
	});
}

const logoElement = document.querySelector(SELECTOR_BASE);
if (logoElement) {
	init(logoElement);
}
